/* SUNVOLT – grönt teknik-avdrag: obligatoriska varukorgsfält (utan Plus).
   Fälten renderas av snippeten sunvolt-gront-avdrag (drawer + /cart) och visas bara när korgen
   innehåller en produkt taggad `gront-avdrag`. Den här filen:
   - speglar värden mellan drawer/cart-kopiorna,
   - validerar personnummer (format + Luhn) och fastighetsbeteckning,
   - sparar som order-attribut via /cart/update.js (samma mönster som Dawns cart-note),
   - LÅSER kassaknappen ([name="checkout"]) och DÖLJER express-/Shop Pay-knapparna
     (.cart__dynamic-checkout-buttons, som annars hoppar förbi korgen) tills fälten är giltiga,
   - re-initierar efter varje korguppdatering (cartUpdate / MutationObserver). */
(function () {
  var saved = { pnr: null, fastighet: null };
  var updateUrl = (window.routes && routes.cart_update_url) || '/cart/update.js';

  function fields(name) {
    return [].slice.call(document.querySelectorAll('[data-sv-gront-field="' + name + '"]'));
  }
  function val(name) {
    var f = fields(name)[0];
    return f ? f.value.trim() : '';
  }
  function required() {
    return !!document.querySelector('[data-sv-gront][data-required="true"]');
  }

  function luhnOk(pnr) {
    var d = (pnr || '').replace(/\D/g, '');
    if (d.length === 12) d = d.slice(2);
    if (d.length !== 10) return false;
    var sum = 0, i, n;
    for (i = 0; i < 10; i++) {
      n = parseInt(d.charAt(i), 10);
      if (i % 2 === 0) { n *= 2; if (n > 9) n -= 9; }
      sum += n;
    }
    return sum % 10 === 0;
  }
  function pnrValid() {
    var v = val('pnr');
    return /^(\d{2})?\d{6}[-+]?\d{4}$/.test(v) && luhnOk(v);
  }
  function fastValid() { return val('fastighet').length > 0; }
  function valid() { return !required() || (pnrValid() && fastValid()); }

  function setErr(name, show) {
    document.querySelectorAll('[data-sv-gront-err="' + name + '"]').forEach(function (e) { e.hidden = !show; });
    fields(name).forEach(function (f) { f.classList.toggle('is-error', show); });
  }
  function setValid(name, ok) {
    fields(name).forEach(function (f) { f.classList.toggle('is-valid', ok); });
  }
  // reveal=true → visa även "tomt obligatoriskt"-fel (vid kassaförsök); annars bara vid ifyllt+ogiltigt.
  // Giltigt ifyllt fält får .is-valid (grön kant + bock) som positiv feedback.
  function refreshErrors(reveal) {
    var p = val('pnr');
    setErr('pnr', (p.length > 0 && !pnrValid()) || (reveal && !pnrValid()));
    setErr('fastighet', reveal && !fastValid());
    setValid('pnr', p.length > 0 && pnrValid());
    setValid('fastighet', fastValid());
  }

  function applyLock() {
    var lock = required() && !valid();
    document.querySelectorAll('[name="checkout"]').forEach(function (b) {
      if (lock) { b.disabled = true; b.dataset.svGrontLock = '1'; }
      else if (b.dataset.svGrontLock) { b.disabled = false; delete b.dataset.svGrontLock; }
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (el) {
      if (lock) { el.style.display = 'none'; el.dataset.svGrontLock = '1'; }
      else if (el.dataset.svGrontLock) { el.style.display = ''; delete el.dataset.svGrontLock; }
    });
  }

  function save() {
    saved = { pnr: val('pnr'), fastighet: val('fastighet') }; // optimistiskt → dirty() blir false direkt
    var body = JSON.stringify({ attributes: { Personnummer: saved.pnr, Fastighetsbeteckning: saved.fastighet } });
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    }).catch(function () {});
  }
  function dirty() {
    return val('pnr') !== saved.pnr || val('fastighet') !== saved.fastighet;
  }

  var saveTimer;
  function onInput(e) {
    var f = e.target, name = f.getAttribute('data-sv-gront-field');
    fields(name).forEach(function (o) { if (o !== f) o.value = f.value; }); // spegla mellan drawer/cart
    refreshErrors(false);
    applyLock();
    clearTimeout(saveTimer);
    saveTimer = setTimeout(save, 500); // persistera strax efter man slutat skriva (täcker express-knapparna)
  }

  function bind(box) {
    if (box.dataset.svBound) return;
    box.dataset.svBound = '1';
    box.querySelectorAll('[data-sv-gront-field]').forEach(function (f) {
      f.addEventListener('input', onInput);
      f.addEventListener('change', save); // blur/ändring → spara attribut
      // Fälten ligger i cart-formuläret → Enter skulle trigga implicit submit (förbi vår
      // kassaknapps-spärr i vissa lägen). Stoppa submit, spara + visa ev. fel i stället.
      f.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); save(); refreshErrors(true); }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-sv-gront]').forEach(bind);
    saved = { pnr: val('pnr'), fastighet: val('fastighet') }; // server-värdena = redan sparade
    refreshErrors(false);
    applyLock();
  }

  // Kassaknappen: garantera att attributen är sparade innan vidare (express-knappar är dolda).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"]');
    if (!btn || !required()) return;
    if (!valid()) {
      e.preventDefault();
      refreshErrors(true);
      var first = document.querySelector('[data-sv-gront-field="pnr"]');
      if (first) first.focus();
      return;
    }
    if (dirty()) {
      e.preventDefault();
      save().then(function () { btn.click(); }); // re-klick: dirty=false → går igenom till kassan
    }
  }, true);

  // Init + re-init efter korguppdatering (drawer/footer re-renderas server-side).
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(init, 50); });
  }
  // Fallback: re-bind när cart-drawerns innehåll byts ut.
  var drawer = document.querySelector('cart-drawer');
  if (drawer && window.MutationObserver) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(init, 60); })
      .observe(drawer, { childList: true, subtree: true });

    // När drawern ÖPPNAS med installation i korgen: scrolla scroll-ytan till botten så att
    // grönt-teknik-formuläret syns direkt (det ligger under produkterna). Vid få produkter
    // finns ingen scroll-yta → no-op (formuläret syns ändå).
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function scrollParentOf(el) {
      var p = el && el.parentElement;
      while (p && p !== document.body) {
        var oy = getComputedStyle(p).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight + 4) return p;
        p = p.parentElement;
      }
      return null;
    }
    new MutationObserver(function () {
      if (!drawer.classList.contains('active') || !required()) return;
      setTimeout(function () {
        var box = document.querySelector('[data-sv-gront]'); if (!box) return;
        var sc = scrollParentOf(box); if (!sc) return;
        sc.scrollTo({ top: sc.scrollHeight, behavior: rm ? 'auto' : 'smooth' });
      }, 450); // vänta in öppningsanimationen
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
})();
